import './ContactForm.scss';
export default function SubmitMessage(){

    return(
        <div className="SubmitMessage">
            <h2>Заявку відправлено</h2>
        </div>


    )
}